import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/** @typedef {typeof globalThis} Window */

class SkioPlanPickerComponent extends Component {
  #variantsData = JSON.parse(this.querySelector('[data-variants-json]')?.textContent)
  #variant;
  #abortController;

  #onVariantUpdate = (event) => {
    if (event.detail.data.productId !== this.dataset.productId) return;
    this.onVariantUpdate(event.detail.resource);
  };

  connectedCallback() {
    super.connectedCallback();

    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });

    this.refs.purchaseType.forEach(input => {
      input.addEventListener('input', this.onPurchaseTypeChange.bind(this), { signal })
    });
    this.refs.sellingPlanInput.addEventListener('change', () => this.onVariantUpdate(this.#variant), { signal });
    this.onVariantUpdate(this.#variantsData.find(variant => String(variant.id) === this.dataset.variantId));
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController?.abort();
  }

  onPurchaseTypeChange() {
    const purchaseType = this.refs.purchaseType.find(input => input.checked)?.value

    this.refs.groupContent.classList[purchaseType === 'one-time' ? 'add' : 'remove']('hidden')

    if (purchaseType === 'one-time') {
      this.refs.sellingPlanInput.removeAttribute('name')
    } else {
      this.refs.sellingPlanInput.setAttribute('name', 'selling_plan')
    }
  }

  onVariantUpdate(variant) {
    this.#variant = variant;
    const oneTimeInput = this.refs.purchaseType.find(input => input.value === 'one-time');
    const subscriptionInput = this.refs.purchaseType.find(input => input.value === 'subscribe');
    const sellingPlanId = this.refs.sellingPlanInput.value
    const allocations = variant?.selling_plan_allocations || [];
    let sellingPlan = allocations.find(plan => String(plan.selling_plan_id) === sellingPlanId);

    if (!sellingPlan) {
      sellingPlan = allocations.find(plan =>
        Array.from(this.refs.sellingPlanInput.options).some(option => option.value === String(plan.selling_plan_id))
      );
      if (sellingPlan) this.refs.sellingPlanInput.value = String(sellingPlan.selling_plan_id);
    }

    subscriptionInput.disabled = !sellingPlan;
    this.refs.subscriptionLabel.classList.toggle('hidden', !sellingPlan);

    if (!sellingPlan) {
      oneTimeInput.checked = true;
      subscriptionInput.checked = false;
    }

    this.refs.oneTimePrice.forEach(el => el.textContent = variant ? this.formatMoney(variant.price / 100) : '');
    this.refs.compareAtPrice.forEach(el => el.textContent = sellingPlan ? this.formatMoney(sellingPlan.compare_at_price / 100) : '');
    this.refs.price.forEach(el => el.textContent = sellingPlan ? this.formatMoney(sellingPlan.price / 100) : '');
    this.onPurchaseTypeChange();
  }

  formatMoney(value) {
    return value.toLocaleString(this.dataset.locale, {
      style: 'currency',
      currency: this.dataset.currencyCode,
    })
  }
}

if (!customElements.get('skio-plan-picker')) {
  customElements.define('skio-plan-picker', SkioPlanPickerComponent);
}
